import React from 'react';
const ManagersIcon: React.FC<{size?: number; color?: string}> = ({ size = 18, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="6.5" cy="7" r="2.5" stroke={color} strokeWidth="1.8" />
    <circle cx="13.5" cy="7" r="2.5" stroke={color} strokeWidth="1.8" />
    <path d="M2.5 16C2.5 13.9 4.3 12.5 6.5 12.5C8.7 12.5 10.5 13.9 10.5 16" stroke={color} strokeWidth="1.8" strokeLinecap="round" />
    <path d="M9.5 16C9.5 13.9 11.3 12.5 13.5 12.5C15.7 12.5 17.5 13.9 17.5 16" stroke={color} strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);
export default ManagersIcon;

